export const CFR_ARTICLES = 'cfrArticles';
